
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../../../../shared/environment.service';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  baseUrl = `${this.env.apiUrl}/user-roles`;
  headers = this.env.getCommonHeaders();
  constructor(public http: HttpClient, public env: EnvironmentService) {}
  fetchUserRoles(params?:any) {//to fetch the list of user roles, pass loc Id for location based list, else omit loc param
    let urlParams = '';
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== ''
      ) {
        if (urlParams === '') {
          urlParams += `?${key}=${params[key]}`;
        } else {
          urlParams += `&${key}=${params[key]}`;
        }
      }
    }
    let url = `user-roles${urlParams}`;
    return this.env.get(url);
  }
  getUserRoleById(roleId: any){//to fetch user role data of specific user role by Id
    let url = `user-roles/${roleId}`;
    return this.env.get(url);
  }

  getUserRolesByLocation(locationId?: string){//to fetch user roles in a specific location
    let url = `user-roles/location/${locationId}`;
    return this.env.get(url);
  }
//to fetch user permissions by location, pass locationId
  getUserPermissionsByLocation(locationId: string): Observable<any> {
    let url = `user-roles/location/permissions/${locationId}`;
    return this.env.get(url);
  }
  updateUserRole(roleId: string, data: any): Observable<any> {
    //to update user role by Id
    let url = `user-roles/${roleId}`;
    return this.env.put(url, data);
  }
}